module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleC3.bdbb4f91.png";